import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, MatSortable } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  take,
  takeUntil,
  tap,
} from "rxjs/operators";
import { AppService } from "src/app/apps/app.service";
import { AudienceContainerComponent } from "src/app/broadcasts/audiences/audience-container/audience-container.component";
import { NotificationService } from "src/app/notifications/notification.service";
import { SessionService } from "src/app/session.service";
import { UiService } from "src/app/ui/ui.service";
import { find, get, sortBy, set } from "lodash";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, forkJoin, merge, Observable, of, Subject } from "rxjs";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { FormControl } from "@angular/forms";
import { ApiService } from "src/app/api.service";
import { FileSaverService } from "ngx-filesaver";
import moment from 'moment';
import { UtilService } from "src/app/util/util.service";
import { LocalStorageService } from "../../storage/local-storage.service";
import { MatDialog } from "@angular/material/dialog";
import { CustomerComponent } from "../customer/customer.component";
import { CustomersService } from "../customers.service";
import { cloneDeep } from "lodash";
import { CustomerSearchDialogComponent } from "src/app/shared/dialogs/customer-search-dialog/customer-search-dialog.component";
import { CustomerSearchService, CustomerRosterSearchPayload } from "src/app/shared/services/customer-search.service";
import { faDownload, faBullhorn, faFileImport } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: "app-roster",
  templateUrl: "./roster.component.html",
  styleUrls: ["./roster.component.scss"],
})
export class RosterComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");
  columnsObj: any[] = [];
  defaultColsObject = [
    {
      id: "appUser.created_at",
      name: "Created At",
      type: "Date",
      selected: true,
      order: -6,
    },{
      id: "appUser.updated_at",
      name: "Updated At",
      type: "Date",
      selected: false,
      order: -6,
    },{
      id: "appUser.last_name",
      name: "Last Name",
      type: "String",
      selected: true,
      order: -5,
    },
    {
      id: "appUser.first_name",
      name: "First Name",
      type: "String",
      selected: true,
      order: -4,
    },
    {
      id: "appUser.email",
      name: "Email",
      type: "String",
      selected: false,
      order: -3,
    },
    {
      id: "appUser.gender",
      name: "Gender",
      type: "String",
      selected: false,
      order: -3,
    },
    {
      id: "appUser.date_of_birth",
      name: "Date of Birth",
      type: "Date",
      selected: false,
      order: -3,
    },
    {
      id: "appUser.company",
      name: "Company",
      type: "String",
      selected: false,
      order: -3,
    },
    {
      id: "locations",
      name: "Current Location",
      type: "String",
      selected: true,
      order: -3,
    },
    {
      id: "appUser.on_property",
      name: "On Property",
      type: "Boolean",
      selected: true,
      order: -2,
    },
    {
      id: "app_version",
      name: "App Version",
      type: "String",
      selected: false,
      order: -2,
    },
    {
      id: "allows_push",
      name: "Allows Push",
      type: "Boolean",
      selected: false,
      order: -2,
    },
    {
      id: "location_permission",
      name: "Location Permission",
      type: "String",
      selected: false,
      order: -2,
    },
    {
      id: "appUser.last_on_property",
      name: "Last On Property",
      type: "Date",
      selected: false,
      order: -1,
    },
    {
      id: "appUser.last_off_property",
      name: "Last Off Property",
      type: "Date",
      selected: false,
      order: -1,
    },
  ]
  customersDataSource!: CustomerRosterDataSource;
  @ViewChild("customersTable") customersTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(AudienceContainerComponent)
  audienceContainer!: AudienceContainerComponent;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  customers: any;
  private _filterOpen: boolean = false;
  displayedColumns!: string[];
  displayedColumnsObj!: {
    id: string;
    name: string;
    type: string;
    selected: boolean;
  }[];
  currentAudience: any;
  hasQsWrite: boolean = false;
  hasQsList: boolean = false;
  hasSignalList: boolean = false;
  hasTemplateList: boolean = false;
  hasAauDetail: boolean = false;
  perPage: number = 20;
  customerCount: number = 0;
  currentPage: number = 0;
  @ViewChild(ElementLoaderDirective)
  customersElementLoader!: ElementLoaderDirective;
  private onComponentDestroy = new Subject();
  private activeSearchV2Payload: CustomerRosterSearchPayload | null = null;
  private activeSavedSearchId: number | null = null;
  faDownload = faDownload;
  faFileImport = faFileImport;
  faBullhorn = faBullhorn;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private AppService: AppService,
    private APIService: ApiService,
    private SessionService: SessionService,
    private NotificationService: NotificationService,
    private cdRef: ChangeDetectorRef,
    private uiService: UiService,
    private fileSaver: FileSaverService,
    private utilSvc: UtilService,
    private localStorageSvc: LocalStorageService,
    private sessionSvc: SessionService,
    private dialog: MatDialog,
    private custSvc: CustomersService,
    private customerSearchService: CustomerSearchService
  ) {}

  ngOnInit(): void {
    this.perPage = this.localStorageSvc.pageSize || 20;
    this.hasQsWrite = this.route.snapshot.data.permissions.hasQsWrite;
    this.hasQsList = this.route.snapshot.data.permissions.hasQsList;
    this.hasSignalList = this.route.snapshot.data.permissions.hasSignalList;
    this.hasTemplateList = this.route.snapshot.data.permissions.hasTemplateList;
    this.hasAauDetail = this.route.snapshot.data.permissions.hasAauDetail;
  }

  onPageChange(e: PageEvent){
    // v2 active: update payload or saved-run with pagination
    if (this.activeSavedSearchId) {
      this.paginator.pageIndex = e.pageIndex;
      this.paginator.pageSize = e.pageSize;
      this.customerSearchService.runSavedSearchWithPagination(this.activeSavedSearchId, e.pageIndex, e.pageSize)
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe((res: any) => {
          this.paginator.length = res.count || 0;
          (this.customersDataSource as any).customersSubject.next(res.records || []);
        });
      return;
    }
    if (this.activeSearchV2Payload) {
      const nextPayload = {
        ...this.activeSearchV2Payload,
        query: {
          ...this.activeSearchV2Payload.query,
          pagination: { page: e.pageIndex, per_page: e.pageSize },
        }
      } as CustomerRosterSearchPayload;
      this.activeSearchV2Payload = nextPayload;
      this.localStorageSvc.setObject(
        'customer_roster_search_v1',
        this.currentAccount.accountID,
        this.currentApp.id,
        nextPayload
      );
      this.customerSearchService.runSearch(nextPayload)
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe((res: any) => {
          this.paginator.length = res.count || 0;
          (this.customersDataSource as any).customersSubject.next(res.records || []);
        });
      return;
    }
    // legacy path
    this.loadCustomersPage(e.pageIndex, e.pageSize).pipe(takeUntil(this.onComponentDestroy)).subscribe()
  }

  ngAfterViewInit() {
    let count = 0;
    let savedColumns = this.localStorageSvc.customerRosterColumns || [];

    // Default columns
    for (let col of sortBy(this.defaultColsObject, 'order')) {
      let savedColIdx = savedColumns.indexOf(col.id);

      this.columnsObj.push({
        id: col.id,
        name: col.name,
        type: col.type,
        selected: savedColumns.length ? (savedColIdx > -1) : col.selected,
        order: col.order + 100,
        group: ['app_version','allows_push','location_permission'].indexOf(col.id) > -1 ? 'device' : 'standard',
      });

      count++;
    }

    // Metacatalog columns
    if (this.behavioralTraits && Array.isArray(this.behavioralTraits)) {
      for (let trait of sortBy(this.behavioralTraits, ['order', 'name'])) {

        if(['Object','Object[]'].indexOf(trait.type) > -1){
          count++;
          continue;
        }

        // Skip duplicates: prefer default columns for common fields
        const canonicalId = (trait.id || '').replace(/^appUser\./, '');
        const isDuplicate = this.columnsObj.some((c) => {
          const cCanonical = (c.id || '').replace(/^appUser\./, '');
          return (
            c.id === trait.id ||
            cCanonical === canonicalId ||
            (c.name || '').toLowerCase() === (trait.name || '').toLowerCase()
          );
        });
        if (isDuplicate) {
          count++;
          continue;
        }

        let savedCol = savedColumns.indexOf(trait.id) > -1;

        if(savedColumns.length === 0 && count < 10){
          savedCol = true;
        }

        this.columnsObj.push({
          id: trait.id,
          name: trait.name,
          type: trait.type,
          selected: savedCol,
          order: 1000,
          group: 'custom',
        });

        count++;
      }
    }

    // Sort columns
    this.columnsObj = sortBy(this.columnsObj, ['order','name']);

    this.displayedColumnsObj = sortBy(this.columnsObj, ['order']).filter(
      (column) => column.selected,
    );

    this.displayedColumns = this.displayedColumnsObj.map((column) => column.id);

    this.customersDataSource = new CustomerRosterDataSource(
      this.AppService,
      this.paginator,
      this.customersElementLoader,
      this.columnsObj,
    );

    this.sort.sort({ id: 'appUser.last_name', start: 'asc'} as MatSortable);

    // Initialize search v2
    this.initOrLoadSearchV2();

    // React to sort changes immediately
    this.sort.sortChange
      .pipe(
        tap(() => (this.paginator.pageIndex = 0)),
        tap(() => this.onSortChanged()),
        takeUntil(this.onComponentDestroy)
      )
      .subscribe();

    // React to keyword changes with debounce
    this.searchValueControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
        debounceTime(300),
        tap(() => this.onKeywordChanged()),
        takeUntil(this.onComponentDestroy)
      )
      .subscribe();

    this.cdRef.detectChanges();

  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      const columnObj = this.columnsObj.find((column) => column.id === this.sort.active);
      const serverField = this.mapColumnIdToServerField(this.sort.active);
      sort.push(`${serverField}:${this.sort.direction}:${columnObj!.type}`);
    }
    return sort;
  }

  private mapColumnIdToServerField(columnId: string): string {
    let serverField = columnId;
    if (serverField.startsWith('appUser.')) {
      const bare = serverField.replace('appUser.', '');
      if (bare === 'on_property') {
        return 'on_property';
      }
      if (bare === 'created_at') {
        return 'created_at';
      }
      if (bare === 'updated_at') {
        return 'updated_at';
      }
      if (bare === 'last_on_property' || bare === 'last_off_property') {
        return bare; // agnostic top-level
      }
      const userFields = [
        'first_name', 'last_name', 'email', 'company', 'gender', 'date_of_birth', 'created_at'
      ];
      if (userFields.indexOf(bare) > -1) {
        serverField = `user.${bare}`;
      } else {
        serverField = `profile.${bare}`;
      }
    } else if (serverField.indexOf('.') === -1) {
      const core = [
        'locations', 'email', 'gender', 'company', 'first_name', 'last_name',
        'on_property', 'created_at', 'last_on_property', 'last_off_property',
        'app_version', 'allows_push', 'location_permission'
      ];
      if (core.indexOf(serverField) === -1) {
        serverField = `profile.${serverField}`;
      }
    }

    // Special case mapping: UI column 'locations' sorts by 'current_location'
    if (serverField === 'locations') {
      serverField = 'current_location';
    }
    return serverField;
  }

  private mapColumnIdToExportKey(columnId: string): string {
    // Normalize UI column ids to backend export column keys
    if (!columnId) { return columnId; }
    if (columnId === 'locations') { return 'current_location'; }

    if (columnId.startsWith('appUser.')) {
      const bare = columnId.replace('appUser.', '');
      const coreUserFields = [
        'first_name', 'last_name', 'email', 'company', 'gender', 'date_of_birth'
      ];
      const topLevelDates = ['created_at', 'updated_at', 'last_on_property', 'last_off_property'];
      if (coreUserFields.indexOf(bare) > -1) { return bare; }
      if (topLevelDates.indexOf(bare) > -1) { return bare; }
      if (bare === 'on_property') { return 'on_property'; }
      return `profile.${bare}`;
    }

    // No namespace provided; decide if core or profile
    const core = [
      'id', 'device_id', 'account_app_user_id', 'account_app_id',
      'first_name', 'last_name', 'company', 'gender', 'email', 'date_of_birth',
      'created_at', 'updated_at', 'on_property', 'last_on_property', 'last_off_property',
      'app_version', 'location_permission', 'allows_push', 'allows_btle', 'current_location'
    ];
    if (core.indexOf(columnId) > -1) { return columnId; }
    if (columnId === 'locations') { return 'current_location'; }
    return `profile.${columnId}`;
  }

  loadCustomersPage(page: number, perPage: number) {

    this.currentPage = page;
    this.perPage = perPage;

    this.paginator.pageIndex = page;
    this.paginator.pageSize = perPage;

    this.localStorageSvc.setPage("customers", this.sessionSvc.currentAccountValue!.accountID, this.sessionSvc.currentAppValue!.id, page);
    this.localStorageSvc.pageSize = perPage;

    this.localStorageSvc.setObject("customersAudience", this.sessionSvc.currentAccountValue!.accountID, this.sessionSvc.currentAppValue!.id, this.currentAudience);
    
    const sort = this.buildSort();

    return this.customersDataSource.loadCustomers(
      this.currentAccount.accountID,
      this.currentApp.id,
      {
        ...this.audienceContainer.filterObj,
        filter: {
          ...this.audienceContainer.filterObj.filter,
          page: page,
          perPage: perPage,
          keyword: this.searchValueText,
          sort,
        },
      },
    );
  }

  get searchValueText() {
    if (this.searchValueControl.value?.length) {
      return this.searchValueControl.value;
    }

    return "";
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue!;
  }

  get currentApp() {
    return this.SessionService.currentAppValue!;
  }

  get behavioralTraits() {
    return this.audienceContainer?.behavioralTraits || [];
  }

  get columns() {
    return sortBy(this.columnsObj, ['name']);
  }

  // Groups for menu rendering
  get deviceColumns() {
    return sortBy(this.columnsObj.filter((c) => c.group === 'device'), ['name']);
  }
  get standardColumns() {
    return sortBy(this.columnsObj.filter((c) => c.group === 'standard'), ['name']);
  }
  get customColumns() {
    return sortBy(this.columnsObj.filter((c) => c.group === 'custom'), ['name']);
  }

  get saveDisabled() {
    const audienceFormInvalid = this.audienceContainer?.audienceForm.invalid;

    let traitFormsInvalid = false;
    for (let traitFormKey of Object.keys(this.audienceContainer?.traitForms)) {
      if (this.audienceContainer?.traitForms[traitFormKey].invalid) {
        traitFormsInvalid = true;
      }
    }

    return audienceFormInvalid || traitFormsInvalid;
  }

  get hasAudience() {
    return this.currentAudience && !this.currentAudience.customFilter;
  }

  get filterOpen() {
    return this._filterOpen;
  }

  set filterOpen(value) {
    this._filterOpen = value;

    if (this.filterOpen) {
      this.searchValueControl.disable();
    } else {
      this.searchValueControl.enable();
    }
  }

  get showSendBroadcastToList() {
    return (
      this.hasQsWrite &&
      this.hasQsList &&
      this.hasSignalList &&
      this.hasTemplateList
    );
  }

  get showClickableUsers() {
    return this.hasAauDetail;
  }

  get showResetSearch() {
    if (this.filterOpen) { return false; }
    if (this.activeSavedSearchId) { return true; }
    if (!this.activeSearchV2Payload) { return false; }
    return !this.isDefaultPayload(this.activeSearchV2Payload);
  }

  private isDefaultPayload(p: CustomerRosterSearchPayload): boolean {
    try {
      const includeDefault = ['appUser','device'];
      const incl = (p.query as any)?.include || [];
      const includeIsDefault = Array.isArray(incl) && incl.length === includeDefault.length && includeDefault.every((v) => incl.includes(v));

      const hasKeyword = !!((p.query as any)?.keyword?.value);
      const hasWhere = !!((p.query as any)?.where);

      const mode = (p.context as any)?.mode || {};
      const regIsDefault = (mode.registration ?? 'both') === 'both';
      const devIsDefault = (mode.devices ?? 'latest_per_user') === 'latest_per_user';
      const includeNullIsDefault = (p.context as any)?.include_null_facilities !== false; // default true

      return includeIsDefault && !hasKeyword && !hasWhere && regIsDefault && devIsDefault && includeNullIsDefault;
    } catch {
      return false;
    }
  }

  toggleFilterDialog() {
    this.filterOpen = !this.filterOpen;
  }

  private sanitizeSort(query: any) {
    if (query && query.sort) {
      const arr = (query.sort as any[]).filter((s: any) => s && s.field && (s.dir === 'asc' || s.dir === 'desc'));
      if (arr.length > 0) {
        query.sort = arr;
      } else {
        delete query.sort;
      }
    }
  }

  private initOrLoadSearchV2() {
    const savedIdObj = this.localStorageSvc.getObject(
      'customer_roster_saved_id',
      this.currentAccount.accountID,
      this.currentApp.id
    );

    if (savedIdObj?.id) {
      this.activeSavedSearchId = savedIdObj.id;
      this.customerSearchService.runSavedSearch(savedIdObj.id).subscribe((res: any) => {
        this.paginator.length = res.count || 0;
        (this.customersDataSource as any).customersSubject.next(res.records || []);
      });
      return;
    }

    const persisted = this.localStorageSvc.getObject(
      'customer_roster_search_v1',
      this.currentAccount.accountID,
      this.currentApp.id
    );

    if (persisted) {
      this.activeSearchV2Payload = persisted;
      this.sanitizeSort((this.activeSearchV2Payload as any).query);
      this.customerSearchService.runSearch(persisted).subscribe((res: any) => {
        this.paginator.length = res.count || 0;
        (this.customersDataSource as any).customersSubject.next(res.records || []);
      });
      return;
    }

    const defaultPayload = this.customerSearchService.buildBasePayload({
      query: {
        include: ["appUser", "device"],
        pagination: { page: 0, per_page: this.perPage },
        sort: [{ field: 'user.last_name', dir: 'asc' }]
      }
    });
    defaultPayload.context.mode = defaultPayload.context.mode || {};
    defaultPayload.context.mode.registration = 'both';
    defaultPayload.context.mode.devices = 'latest_per_user';
    // Preserve persisted include flag if present; fall back to defaults
    defaultPayload.context.include_null_facilities =
      typeof defaultPayload.context.include_null_facilities === 'boolean' ? defaultPayload.context.include_null_facilities : true;
    this.sanitizeSort((defaultPayload as any).query);
    this.activeSearchV2Payload = defaultPayload;

    this.localStorageSvc.setObject(
      'customer_roster_search_v1',
      this.currentAccount.accountID,
      this.currentApp.id,
      defaultPayload
    );
    this.customerSearchService.runSearch(defaultPayload).subscribe((res: any) => {
      this.paginator.length = res.count || 0;
      (this.customersDataSource as any).customersSubject.next(res.records || []);
    });
  }

  private onKeywordChanged() {
    if (this.activeSavedSearchId) {
      this.customerSearchService.runSavedSearch(this.activeSavedSearchId).subscribe((res: any) => {
        this.paginator.length = res.count || 0;
        (this.customersDataSource as any).customersSubject.next(res.records || []);
      });
      return;
    }
    if (this.activeSearchV2Payload) {
      const nextPayload = {
        ...this.activeSearchV2Payload,
        query: {
          ...this.activeSearchV2Payload.query,
          keyword: this.searchValueText ? { value: this.searchValueText } : undefined
        }
      } as CustomerRosterSearchPayload;
      this.activeSearchV2Payload = nextPayload;
      this.localStorageSvc.setObject(
        'customer_roster_search_v1',
        this.currentAccount.accountID,
        this.currentApp.id,
        nextPayload
      );
      this.customerSearchService.runSearch(nextPayload).subscribe((res: any) => {
        this.paginator.length = res.count || 0;
        (this.customersDataSource as any).customersSubject.next(res.records || []);
      });
    }
  }

  private onSortChanged() {
    if (this.activeSavedSearchId) {
      // Re-run saved search; server will use its saved sort (cannot override without payload)
      this.customerSearchService.runSavedSearch(this.activeSavedSearchId).subscribe((res: any) => {
        this.paginator.length = res.count || 0;
        (this.customersDataSource as any).customersSubject.next(res.records || []);
      });
      return;
    }
    if (this.activeSearchV2Payload) {
      const nextPayload = {
        ...this.activeSearchV2Payload,
        query: {
          ...this.activeSearchV2Payload.query,
          pagination: { ...(this.activeSearchV2Payload.query?.pagination || { page: 0, per_page: this.perPage }), page: 0 },
        }
      } as CustomerRosterSearchPayload;

      if (this.sort.direction === '') {
        if ((nextPayload as any).query && (nextPayload as any).query.sort !== undefined) {
          delete (nextPayload as any).query.sort;
        }
      } else {
        const serverField = this.mapColumnIdToServerField(this.sort.active);
        (nextPayload as any).query.sort = serverField ? [{ field: serverField, dir: this.sort.direction }] : undefined;
      }

      this.activeSearchV2Payload = nextPayload;
      this.localStorageSvc.setObject(
        'customer_roster_search_v1',
        this.currentAccount.accountID,
        this.currentApp.id,
        nextPayload
      );
      this.customerSearchService.runSearch(nextPayload).subscribe((res: any) => {
        this.paginator.length = res.count || 0;
        (this.customersDataSource as any).customersSubject.next(res.records || []);
      });
    }
  }

  resetSearchV2() {
    // Clear persisted keys for current account/app
    this.localStorageSvc.setObject(
      'customer_roster_saved_id',
      this.currentAccount.accountID,
      this.currentApp.id,
      null
    );
    this.localStorageSvc.setObject(
      'customer_roster_search_v1',
      this.currentAccount.accountID,
      this.currentApp.id,
      null
    );
    this.activeSavedSearchId = null;

    // Rebuild default payload
    const defaultPayload = this.customerSearchService.buildBasePayload({
      query: {
        include: ["appUser", "device"],
        pagination: { page: 0, per_page: this.perPage },
        sort: [{ field: 'user.last_name', dir: 'asc' }]
      }
    });
    defaultPayload.context.mode = defaultPayload.context.mode || {};
    defaultPayload.context.mode.registration = 'both';
    defaultPayload.context.mode.devices = 'latest_per_user';
    this.activeSearchV2Payload = defaultPayload;

    // Persist and run
    this.localStorageSvc.setObject(
      'customer_roster_search_v1',
      this.currentAccount.accountID,
      this.currentApp.id,
      defaultPayload
    );
    this.customerSearchService.runSearch(defaultPayload).subscribe((res: any) => {
      this.paginator.length = res.count || 0;
      (this.customersDataSource as any).customersSubject.next(res.records || []);
    });
  }

  formatDate = (date: Date) => {
    return this.utilSvc.formatDate(date);
  }

  exportToExcel() {
    this.exportWithCurrentFilters('xlsx');
  }

  exportToCsv() {
    this.exportWithCurrentFilters('csv');
  }

  private exportWithCurrentFilters(format: 'xlsx' | 'csv') {
    // Prefer the v2 payload that drives the current grid. If a saved search is active,
    // resolve its stored payload first to ensure we export using the exact same filters.
    const filename = format === 'xlsx'
      ? moment().format('[LHPECustomers-]YYYY-MM-DD-HH-mm-ss[.xlsx]')
      : moment().format('[LHPECustomers-]YYYY-MM-DD-HH-mm-ss[.csv]');

    const performExport = (basePayload: CustomerRosterSearchPayload) => {
      const selectedColumns = (this.displayedColumnsObj || [])
        .filter((c: any) => c && c.id)
        .map((c: any) => ({ key: this.mapColumnIdToExportKey(c.id), header: c.name }))
        .filter((v: any) => !!v.key)
        .filter((v: any, idx: number, arr: any[]) => arr.findIndex((x: any) => x.key === v.key) === idx);

      const hasForeignId = selectedColumns.some((c: any) => c.key === 'foreign_id');
      if (!hasForeignId) {
        selectedColumns.push({ key: 'foreign_id', header: 'Foreign ID' });
      }

      const payload: any = {
        ...basePayload,
        schema_version: 1,
        query: {
          ...(basePayload.query || {}),
          // Export should not be paginated; ask server for all rows.
          pagination: { page: 0, per_page: -1 },
          export: { format, columns: selectedColumns },
        },
      };

      // If registration mode is "both", the backend will return JSON not a file.
      // Keep filters unchanged per user request; block with a helpful message.
      const registrationMode = payload?.context?.mode?.registration;
      if (registrationMode === 'both') {
        this.NotificationService.openErrorSnackBar(
          'Export is unavailable when Registration mode is "both". Choose Registered or Anonymous.'
        );
        return;
      }

      this.sanitizeSort(payload.query);

      this.uiService
        .waitForEvent(
          this.APIService.post(
            `account-apps-device/${this.currentAccount.accountID}/app/${this.currentApp.id}/search`,
            payload,
            { responseType: 'blob' }
          )
        )
        .subscribe(
          (res) => this.fileSaver.save((res as any), filename),
          (error) => console.error('download error:', error)
        );
    };

    if (this.activeSavedSearchId) {
      // Load the saved search definition to get the exact payload used for on-screen results
      this.customerSearchService.listSavedSearches()
        .pipe(takeUntil(this.onComponentDestroy), take(1))
        .subscribe((res: any) => {
          const records = res?.records || res || [];
          const saved = records.find((s: any) => s?.id === this.activeSavedSearchId);
          const savedPayload: CustomerRosterSearchPayload | undefined = saved?.query;
          if (!savedPayload) {
            this.NotificationService.openErrorSnackBar('Unable to load saved search definition for export.');
            return;
          }
          performExport(savedPayload);
        });
      return;
    }

    if (this.activeSearchV2Payload) {
      performExport(this.activeSearchV2Payload);
      return;
    }

    // Legacy path: mirror existing behavior using filter endpoint; keep same filters as on screen
    const sort = this.buildSort();
    const legacyFilename = filename;
    this.uiService
      .waitForEvent(
        this.APIService.post(
          `account-apps-device/${this.currentAccount.accountID}/app/${this.currentApp.id}/filter`,
          {
            ...this.audienceContainer.filterObj,
            filter: {
              ...this.audienceContainer.filterObj.filter,
              page: this.paginator.pageIndex,
              perPage: this.paginator.pageSize,
              keyword: this.searchValueText,
              sort,
              forExport: true
            },
          },
          { responseType: 'blob' }
        )
      )
      .subscribe(
        (res) => this.fileSaver.save((res as any), legacyFilename),
        (error) => console.error('download error:', error)
      );
  }

  onCustomerSelected(row: any) {

    this.uiService.waitForEvent(forkJoin(

      // Anonyous
      row.account_app_user_id === null ? 
      [
        this.AppService.getAppDevice(
          this.SessionService.currentAccountValue!.accountID,
          row.id,
        ),
        this.AppService.getAppDeviceLocationHistory(
          this.SessionService.currentAccountValue!.accountID,
          row.id,
        ).pipe(take(1)),
        this.AppService.getAppDeviceSignalHistory(
          this.SessionService.currentAccountValue!.accountID,
          row.id,
        ).pipe(take(1))
      ] 
        : 

      // Authenticated
      [
      this.AppService.getUser(
        this.SessionService.currentAccountValue!.accountID,
        row.account_app_user_id,
      ),
      this.AppService.getAppUserLocationHistory(
        this.SessionService.currentAccountValue!.accountID,
        row.account_app_user_id,
      ).pipe(take(1)),
      this.AppService.getAppUserSignalHistory(
        this.SessionService.currentAccountValue!.accountID,
        row.account_app_user_id,
      ).pipe(take(1))
    ])).subscribe((customer: any) => {
      const dialogRef = this.dialog.open(CustomerComponent, {
        panelClass: 'app-full-bleed-dialog',
        width: '100%',
        height: '80%',
        data: {
          customer: customer[0],
          locationHistory: customer[1],
          signalHistory: customer[2]
        }
       });
       dialogRef.afterClosed().subscribe((result) => {
        if(result === "sendPrivateBroadcast"){
          let cust = customer[0];
          this.router.navigate(["createBroadcast"], {
            state: {
              audience: {
                count: 1,
                customer_id: cust.id,
                device_count: cust.appDevices?.length ?? 0,
                facility_id: this.SessionService.facilitiesValue!.map((facility) => {
                  return facility.id;
                }),
                single_customer_qs: true,
                name: cust.first_name && cust.last_name ? `${cust.first_name} ${cust.last_name}` : "No customer name",
              },
            },
            relativeTo: this.route.parent,
          });
        }
       });
    })
   
  }

  onColumnSelectionChange(event: MatCheckboxChange, column: any) {
    

    column.selected = !column.selected;

    this.displayedColumnsObj = this.columnsObj.filter(
      (column) => column.selected,
    );
    this.displayedColumns = this.displayedColumnsObj.map((column) => column.id);
    
    this.localStorageSvc.customerRosterColumns = this.displayedColumns;

    this.customersTable.renderRows();
  }

  resetColumnsToDefault() {
    // Reset selected flags based on defaultColsObject (first 10 logic for traits preserved)
    const defaultSelectedIds = sortBy(this.defaultColsObject, 'order')
      .filter(col => col.selected)
      .map(col => col.id);

    this.columnsObj = this.columnsObj.map((c) => ({
      ...c,
      selected: defaultSelectedIds.indexOf(c.id) > -1
    }));

    this.displayedColumnsObj = this.columnsObj.filter((column) => column.selected);
    this.displayedColumns = this.displayedColumnsObj.map((column) => column.id);
    this.localStorageSvc.customerRosterColumns = this.displayedColumns;
    this.customersTable.renderRows();
  }

  resetFilters() {
    this.audienceContainer.ngOnInit();
  }

  applyFilters() {
    if (
      this.audienceContainer.audienceForm.controls.audienceName.value?.length
    ) {
      if (this.hasAudience) {
        this.updateAudience()
          .pipe(
            tap((audience) => {
              console.log("Audience updated")
              this.currentAudience = audience;
              this.filterOpen = false;
              switchMap(() => this.loadCustomersPage(0, this.perPage));
            }),
            takeUntil(this.onComponentDestroy),
          )
          .subscribe();
      } else {
        this.createAudience()
          .pipe(
            tap((audience) => {
              console.log("Audience created")
              this.currentAudience = audience;
              this.filterOpen = false;
            }),
            switchMap(() => this.loadCustomersPage(0, this.perPage)),
            takeUntil(this.onComponentDestroy),
          )
          .subscribe(() => {});
      }
    } else {
      this.filterOpen = false;
      this.currentAudience = {
        ...this.audienceContainer.filterObj.filter,
        keyword: this.searchValueControl.value,
        name: "Custom Filter",
        customFilter: true,
      };

      this.loadCustomersPage(0, this.perPage)
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe();
    }
  }

  sendBroadcastToList() {
    const audience = {
      ...this.audienceContainer.filterObj.filter,
      keyword: this.searchValueControl.value,
      name: "Custom Filter",
      customFilter: true,
    };
    this.router.navigate(["createBroadcast"], {
      relativeTo: this.route.parent,
      state: { audience },
    });
  }

  createAudience() {
    return this.uiService
      .waitForEvent(
        this.AppService.createAudience(
          this.currentAccount.accountID,
          this.currentApp.id,
          this.audienceContainer?.audienceDTO,
        ),
      )
      .pipe(
        map(
          (audience) => {
            this.NotificationService.openSuccessSnackBar("Audience created");
            return audience;
          },
          () => {
            this.NotificationService.openErrorSnackBar(
              "Error creating Audience",
            );
          },
        ),
      );
  }

  updateAudience() {
    return this.uiService
      .waitForEvent(
        this.AppService.updateAudience(
          this.currentAccount.accountID,
          this.currentApp.id,
          this.currentAudience.id,
          this.audienceContainer?.audienceDTO,
        ),
      )
      .pipe(
        map(
          (audience) => {
            this.NotificationService.openSuccessSnackBar("Audience updated");
            return audience;
          },
          () => {
            this.NotificationService.openErrorSnackBar(
              "Error updating Audience",
            );
          },
        ),
      );
  }

  refineCustomers(audience: any) {
    const filterDTO = {
      facility_id: this.SessionService.facilitiesValue!.map((facility) => {
        return facility.id;
      }),
      filter: audience,
    };

    return this.uiService
      .waitForEvent(
        this.AppService.getFilter(
          this.currentAccount.accountID,
          this.currentApp.id,
          filterDTO,
        ),
      )
      .pipe(
        map(
          (res: any) => {
            return res.records;
          },
          () => {
            this.NotificationService.openErrorSnackBar(
              "Error retrieving Customers",
            );
          },
        ),
      );
  }

  displayValueForProfileData(column: any, row: any) {
    let cId = column.id.split(".")[column.id.split(".").length - 1];
    let f = this.SessionService.currentAccountValue?.catalog?.app_users?.profile?.find((field: any) => field.id === cId);
    let value = null;
    if(f === undefined){
      f = cloneDeep(column)
      f._type = column.type
      // Try multiple locations for backward/forward compatibility
      value = get(row, f.id) ?? get(row, f.id.replace('appUser.', '')) ?? get(row, `profile.${cId}`);
    } else {
      value = get(row, `profile.${f.id}`) ?? get(row, "appUser.profile."+f.id);
    }

    // Special formatting for roster-only fields
    if (cId === 'location_permission') {
      const locPermission: any = {
        0: 'Unknown',
        1: 'Restricted',
        2: 'Denied',
        3: 'Always',
        4: 'When in use',
      };
      value = (value === null || value === undefined) ? value : (locPermission[value] ?? value);
    }
    return this.custSvc.formatData(f, value);
  }

  openSearchDialog() {
    const dialogRef = this.dialog.open(CustomerSearchDialogComponent, {
      width: '100%',
      data: {
        context: this.activeSearchV2Payload?.context,
        initialQuery: this.activeSearchV2Payload?.query,
        selectedSavedId: this.activeSavedSearchId || undefined
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) { return; }
      if (result.type === 'search' && result.payload) {
        this.activeSavedSearchId = null;
        this.paginator.pageIndex = 0;
        this.currentPage = 0;
        if (result.payload.query) {
          result.payload.query.pagination = result.payload.query.pagination || { page: 0, per_page: this.perPage };
          result.payload.query.pagination.page = 0;
        }
        this.sanitizeSort(result.payload.query);
        this.activeSearchV2Payload = result.payload;
        this.localStorageSvc.setObject(
          'customer_roster_search_v1',
          this.currentAccount.accountID,
          this.currentApp.id,
          this.activeSearchV2Payload
        );
        this.uiService
          .waitForEvent(this.customerSearchService.runSearch(result.payload))
          .subscribe((res: any) => {
            this.paginator.length = res.count || 0;
            (this.customersDataSource as any).customersSubject.next(res.records || []);
          });
      } else if (result.type === 'saved' && result.id) {
        this.activeSearchV2Payload = null;
        this.activeSavedSearchId = result.id;
        this.paginator.pageIndex = 0;
        this.currentPage = 0;
        this.localStorageSvc.setObject(
          'customer_roster_saved_id',
          this.currentAccount.accountID,
          this.currentApp.id,
          { id: this.activeSavedSearchId }
        );
        this.uiService
          .waitForEvent(this.customerSearchService.runSavedSearch(result.id))
          .subscribe((res: any) => {
            this.paginator.length = res.count || 0;
            (this.customersDataSource as any).customersSubject.next(res.records || []);
          });
      }
    });
  }
}

export class CustomerRosterDataSource implements DataSource<any> {
  private customersSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private AppService: AppService,
    private Paginator: MatPaginator,
    private customersElementLoader: ElementLoaderDirective,
    private columns: any[],
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.customersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.customersSubject.complete();
  }

  loadCustomers(masterAccountID: number, appID: number, filterDTO: any) {
    return this.customersElementLoader
      .waitForEvent(
        this.AppService.getFilter(masterAccountID, appID, filterDTO).pipe(
          catchError(() => of({ count: 0, records: [] })),
        ),
      )
      .pipe(
        tap((filter: any) => {
          for (let trait of this.columns) {
            const field = trait.id.replace("appUser.", "");
            const altField = field === 'locations' ? 'current_location' : field;

            for (let customer of filter.records) {
              const value =
                get(customer, trait.id) ??
                get(customer, altField) ??
                get(customer, field) ??
                get(customer, `profile.${altField}`) ??
                get(customer, `profile.${field}`) ??
                get(customer, `appUser.profile.${field}`);
              if (value !== undefined) {
                set(customer, trait.id, value);
              }
            }
          }

          this.Paginator.length = filter.count;
          this.customersSubject.next(filter.records);
        }),
      );
  }
}
